module.exports = __webpack_public_path__ + "static/media/m_eyeshape_downturned_lightbrown.e0b3e37f.png";